import createTradePlanCopy from '../../../../../../../../classes/tradePlan/createTradePlanCopy';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { addTradePlan } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/addtradeplanmessage/addTradePlan';
import { WebsocketStore } from '../../../../../../../../stores/websocketStore/websocketStore';
import { submitTradePlan } from '../BreakBounceSetup/submitTradePlan';

interface Props {
  data: string;
  tradePlanForm: TradePlanData;
  candleDuration: number;
  timeUnit: string;
  autoSend: boolean;
  websocketStore: WebsocketStore | null;
}

export function addCandleBreak({
  data,
  tradePlanForm,
  candleDuration,
  timeUnit,
  autoSend,
  websocketStore,
}: Props) {
  const quantityBasisValue = tradePlanForm.currentQuantityBasisValue;
  let direction = data;

  // TODO refactor this logic

  // reconcile provided direction with Long/Short checkboxes
  // reconcile data and tradePlanForm.direction
  let errMsg = null;
  if( data === 'SHORT' && tradePlanForm.goLong && !tradePlanForm.goShort ) {
    errMsg = `Cannot use Candle Break short on a Long-only Trade Plan`
  } else if( data === 'LONG' && !tradePlanForm.goLong && tradePlanForm.goShort ) {
    errMsg = `Cannot use Candle Break long on a Short-only Trade Plan`
  } else if( data === 'BOTH' && !tradePlanForm.goLong ) {
    direction = 'SHORT'
  } else if( data === 'BOTH' && !tradePlanForm.goShort ) {
    direction = 'LONG'
  }
  if( errMsg ) {
    tradePlanForm.setValidationStatus({
      status: false,
      message: errMsg,
    });
    return
  }

  // TODO Candle Break should really be in the order type section as a modifier to a setup

  if (autoSend) {
    //TODO: way to add handle CANDLE_BREAK when auto sending with bounce or Break 9/9/2022
    if (tradePlanForm.setup === 'BREAK' || tradePlanForm.setup === 'BOUNCE') {
      // I believe this is unlikely to happen.  The user would have to add the Break/Bounce, then check AutoSend, and then use the CandleBreak context menu to end up here.  And, as suspected, the return below seems to do nothing.
      tradePlanForm.clearEntryTactics();  // remove MARKET_ORDER and anything else
      tradePlanForm.addEntryTactic('CANDLE_BREAK', {
        candleDuration,
        quantityBasisValue,
      });
      return;
    } else {

      const newInstance = createTradePlanCopy({
        tradePlanDataInstance: tradePlanForm,
        keysToOverWrite: { goLong: direction !== 'SHORT', goShort: direction !== 'LONG' },
        websocketStore,
      });
      if (timeUnit === 'MINUTES') {
        newInstance.setSetup('AD_HOC');
        newInstance.setDirection(direction);
        newInstance.clearEntryTactics();  // remove MARKET_ORDER and anything else
        newInstance.addEntryTactic('CANDLE_BREAK', {
          candleDuration,
          quantityBasisValue,
        });
      } else {
        newInstance.setDirection(direction);
        newInstance.setSetup('CANDLE_TRIGGER', {
          candleDuration,
          timeUnit,
        });
      }
      // const instrument = tradePlanForm.instrument;
      // const overrides = {}
      // if (instrument === 'option') {
        // TODO refactor this
        // submitTradePlan({ currentPrice: 0, tradePlanForm, overrides, websocketStore });
      // } else {
        const validationResult = tradePlanForm.validate();
        if (validationResult.status === false) {
          tradePlanForm.setValidationStatus(validationResult);
          return newInstance;   // who is this returning to?
        } else {
          const tpData = newInstance.returnJson();
          let optionData;
          if( newInstance.instrument === 'option' ) {
            optionData = tradePlanForm.optionManagement.returnJson();
          }
          addTradePlan({ tradePlanObject: tpData, options: optionData });
          tradePlanForm.setValidationStatus({
            status: true,
            message: 'Trade Plan Submitted',
          });
          return newInstance;   // who is this returning to?
        }
      }
    // }
  } else {
    if (timeUnit === 'MINUTES') {
      // TODO reconcile with Break/Bounce and direction
      // tradePlanForm.setSetup('AD_HOC');
      // tradePlanForm.clearEntryTactics();

      // TODO this update conflicts with the send confirmation
      // TODO I think there's still a bug here when both checkboxes are checked, but you choose only one direction.
      if( direction === 'BOTH' && (tradePlanForm.goShort !== tradePlanForm.goLong) ) {
        tradePlanForm.setValidationStatus({
          status: false,
          message: 'Long/Short checkboxes changed',
        });
      }

      tradePlanForm.setDirection(direction);   // TODO this changes the form!

      tradePlanForm.clearEntryTactics();  // remove MARKET_ORDER and anything else
      tradePlanForm.addEntryTactic('CANDLE_BREAK', {
        candleDuration,
        quantityBasisValue,
      });
    } else {
      //TODO: Reconcile with bounce & break. 9/9/2022
      tradePlanForm.setDirection(direction);
      tradePlanForm.setSetup('CANDLE_TRIGGER', {
        candleDuration,
        timeUnit,
      });
    }
    return tradePlanForm;
  }
}
